exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".login-wrapper{padding:20pt;background:#fff}", "", {"version":3,"sources":["/home/steven/dev/Sporte/sporte2/src/components/Login.vue"],"names":[],"mappings":"AAKA,eACE,aAAc,AACd,eAAkB,CACnB","file":"Login.vue","sourcesContent":["\n.login{\n  /* width: 40%; */\n  /* margin: auto; */\n}\n.login-wrapper {\n  padding: 20pt;\n  background: white;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-99211752","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Login.vue
// module id = 728
// module chunks = 15